import {CreateDialogButton} from '@/components/refinedev/dialogs/create-dialog-button';
import ProjectForm from '../project-form';
import AutocompleteInput from '@/components/refinedev/AutocompleteInput';
import {ProjectAutocompleteInput} from './project-autocomplete-input';

export const CreateProjectDialogButton = ({onSuccess}: {onSuccess?: (data) => void}) => {
  return (
    <CreateDialogButton
      resource={'projects'}
      title="Tạo dự án"
      transformBeforeSave={ProjectForm.transformBeforeSave}
      formProps={{
        refineCoreProps: {
          onMutationSuccess: onSuccess,
        },
      }}>
      <div className="flex flex-col gap-4">
        <ProjectForm.GeneralInfo />
        <ProjectAutocompleteInput
          source="template_project"
          label="Sao chép workflow từ dự án có sẵn"
        />
      </div>
    </CreateDialogButton>
  );
};
